import React from "react";
import Header from "./Components/Header";
import Catalog from "./Components/Catalog";
function App() {
  return (
    <div className="App">
      <Header />
      <Catalog />
    </div>
  );
}

export default App;
